import Api from '@/Api'

export default class ContactsApi extends Api {
  /**
   * Requests the API to send a list of contacts given a group ID
   * @param {Object}          params - key/value pair to be provided as url query parameters
   */

  requestContacts = (params) => {
    if (params.isInternalUser && !params.groupCk && !params.parentGroupCk) { throw new Error('Internal users must have a parent group & group in context to get contacts.') }
    else if (params.groupCk || params.parentGroupCk) {
      let payload = {
        groupCk: params.groupCk,
        parentGroupCk: params.parentGroupCk
      } 
      return this.post('/api/v1/private/groups/contacts', payload)
    } else { return this.post('/api/v1/private/groups/contacts') }
  }
}
